$(document).ready(function () {
  $('[data-name="save"]').on('click', function () {
    $('.notice').fadeOut('200');
  });
});